import PopImg from "../assets/popupImg.png";
import IconClose from "../../../assets/icones/icons dense (24px)/fechar - white.svg";
import { Overlay, Wrapperbanner, WrapperClose } from "./styles";

interface PopUpProps {
  close: () => void;
}
const PopUp = ({ close }: PopUpProps) => {
  return (
    <Overlay>
      <Wrapperbanner>
        <a
          href="https://coobrasturltda.sharepoint.com/:b:/s/EQP-MARKETING-EXT/EdCuALty1uBMhC6WDBSlltEBuqL_j2KiYS4wqGcZmSQmiQ?e=uezLdX"
          target="_blanck"
        >
          <img
            src={PopImg}
            alt="lista de hoteis credenciados, clique aqui"
            width="100%"
          />
        </a>
        <WrapperClose>
          <img
            src={IconClose}
            alt="fechar-popUp"
            onClick={close}
            width="100%"
          />
        </WrapperClose>
      </Wrapperbanner>
    </Overlay>
  );
};

export default PopUp;
